 import React from 'react'
import {Map as LeafletMap, TileLayer } from "react-leaflet";
import { showDataOnMap } from './utils';
import './Map.css' 
 
   
function Map({center, zoom, countries, casesType}) {     
    
    console.log(countries) //response from coutries is not an array 

  
    return (
        <div className='map'> 
             
            <LeafletMap center = {center} zoom = {zoom}  >
                <TileLayer
                 url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                //attribution is all about giving crwdit to the creators of the map
                attribution='&copy;<a href ="http://osm.org/copyright">
                            OpenStreetMap</a> contributors'/>
             {showDataOnMap(countries, casesType)} 
            </LeafletMap>
            
        </div>
    )
}

export default Map
